import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import messages from "../../../assets/locale/messages";
import { getClientPortalCompanies } from "../../../network/apis/clientPortalCompanies";
import { loginResponse } from "../../../store/Auth/actions";
import { setAdmin } from "../../../utils/Auth";
import {
  applyClientCompanySelection,
  clientHasMultipleCompanies,
  getClientCompanies,
  resolveClientPostLoginRoute,
} from "../../../utils/clientPortal";
import { ROUTE_PATHS } from "../../../utils/RoutesPaths";

import ClientCompanySelectionView from "./ClientCompanySelectionView";

import "./ClientCompanySelection.scss";

const ClientCompanySelection = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const lang = useSelector((state) => state.locale.lang);
  const login = useSelector((state) => state.auth.login);
  const copy = messages[lang].clientCompanySelection;

  const [companies, setCompanies] = useState(() => getClientCompanies(login));

  useEffect(() => {
    if (!clientHasMultipleCompanies(login)) {
      history.replace(resolveClientPostLoginRoute(login));
      return;
    }

    let cancelled = false;

    getClientPortalCompanies({ page: -1 })
      .then((companiesResponse) => {
        if (cancelled) return;
        const companyRows = companiesResponse?.data?.data;
        if (Array.isArray(companyRows) && companyRows.length > 0) {
          setCompanies(companyRows);
        }
      })
      .catch(() => {
        /* keep companies from login payload */
      });

    return () => {
      cancelled = true;
    };
  }, [history, login, lang]);

  const clientName = useMemo(() => {
    const name = login?.name?.trim();
    return name || login?.email || "";
  }, [login?.email, login?.name]);

  const welcomeTitle = copy.welcomeTitle.replace("{name}", clientName);
  const welcomeSubtitle = copy.welcomeSubtitle.replace(
    "{count}",
    String(companies.length),
  );
  const activeCountLabel = copy.activeCount.replace(
    "{count}",
    String(companies.length),
  );

  const handleSelectCompany = useCallback(
    (company) => {
      const nextLogin = applyClientCompanySelection(login, company);
      dispatch(loginResponse(nextLogin));
      setAdmin(nextLogin);
      history.push(ROUTE_PATHS.clientPortalEvents);
    },
    [dispatch, history, login],
  );

  return (
    <ClientCompanySelectionView
      welcomeTitle={welcomeTitle}
      welcomeSubtitle={welcomeSubtitle}
      sectionTitle={copy.sectionTitle}
      activeCountLabel={activeCountLabel}
      partnerLabel={copy.partnerCompany}
      selectAriaLabel={copy.selectCompanyAria}
      lang={lang}
      companies={companies}
      onSelectCompany={handleSelectCompany}
    />
  );
};

export default ClientCompanySelection;
